export const GET_LAST_TASK = 'GET_LAST_TASK';
export const GET_LAST_TASK_SUCCESS = 'GET_LAST_TASK_SUCCESS';
export const GET_LAST_TASK_ERROR = 'GET_LAST_TASK_ERROR';
